<template>
	<BaseContenedor>
		<BaseButton
			style-button="success"
			style-class="right floated"
			@click="imprimir"
		>
			<i class="download icon"></i>
			IMPRIMIR
		</BaseButton>
		<br />
		<br />
		<br />
		<div id="printMe">
			<div class="ui segment ">
				<div class="ui grid">
					<div class="twelve wide column center aligned">
						<h2>
							{{ getNombrePlantel }}
						</h2>
					</div>
					<div class="four wide column center aligned">
						<img
							class="ui mini image"
							:src="getLogoPlantel"
							style="width: 45px;"
						/>
					</div>
				</div>
			</div>
			<div v-for="examen in examenesAspirantes" :key="`${examen.ficha}`">
				<br />
				<div class="ui segment ">
					<div class="ui two column grid">
						<div class="column">
							<base-mostrar-dato titulo="Ficha" :valor="examen.ficha" />
						</div>
						<div class="column">
							<base-mostrar-dato
								titulo="Nombre completo"
								:valor="examen.nombreCompleto"
							/>
						</div>
					</div>
					<div class="ui two column grid">
						<div class="column">
							<base-mostrar-dato titulo="CURP" :valor="examen.curp" />
						</div>
						<div class="column">
							<base-mostrar-dato
								titulo="Carrera"
								:valor="
									`${examen.claveCarrera} - ${examen.nombreCortoCarrera || ''}`
								"
							/>
						</div>
					</div>
				</div>
				<table class="ui table celled sortable compact">
					<thead>
						<tr>
							<th class="boldFont greyColor one wide"
								><b class="boldFont greyColor"> Área </b></th
							>
							<th class="boldFont greyColor one wide"
								><b class="boldFont greyColor"> Sección </b></th
							>
							<th class="boldFont greyColor one wide"
								><b class="boldFont greyColor"> Pregunta </b></th
							>
							<th class="boldFont greyColor four wide"
								><b class="boldFont greyColor"> Respuesta Dada </b></th
							>
							<th class="boldFont greyColor four wide"
								><b class="boldFont greyColor"> Respuesta Correcta </b></th
							>
							<th class="boldFont greyColor one wide"
								><b class="boldFont greyColor"> Correctas </b></th
							>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(row, ir) in examen.tabla" :key="ir">
							<template v-if="row.area">
								<td
									colspan="6"
									class="boldFont greyColor descending"
									style="background:#f9fafb;"
								>
									<b class="boldFont greyColor">
										{{ row.area.clave }} - {{ row.area.nombre }}
									</b>
								</td>
							</template>
							<template v-else-if="row.seccion">
								<td class="boldFont greyColor descending">
									&nbsp;
								</td>
								<td
									colspan="5"
									class="boldFont greyColor descending"
									style="background:#f9fafb;"
								>
									<b class="boldFont greyColor">
										{{ row.seccion.clave }} - {{ row.seccion.nombre }}
									</b>
								</td>
							</template>
							<template v-else-if="row.pregunta">
								<td colspan="2" class="boldFont greyColor descending">
									&nbsp;
								</td>
								<td colspan="3" class="boldFont greyColor descending">
									<base-mostrar-markdown
										style="display: inline-block;"
										:agregado="
											row.preguntaExamenAspirante.clave
												? `**${row.preguntaExamenAspirante.clave}.**`
												: undefined
										"
										:contenido="row.pregunta.contenido"
									/>
								</td>
								<td
									rowspan="2"
									class="boldFont greyColor descending center aligned"
								>
									<i
										v-show="row.preguntaExamenAspirante.contestoCorrectamente"
										class="large green checkmark icon"
									></i>
									<i
										v-show="
											!row.preguntaExamenAspirante.respuestaDada &&
												!row.preguntaExamenAspirante.contestoCorrectamente
										"
										class="large yellow minus icon"
									></i>
									<i
										v-show="
											row.preguntaExamenAspirante.respuestaDada &&
												!row.preguntaExamenAspirante.contestoCorrectamente
										"
										class="large red close icon"
									></i>
								</td>
							</template>
							<template v-else-if="row.respuestaDada || row.respuestaCorrecta">
								<td colspan="3" class="boldFont greyColor descending">
									&nbsp;
								</td>
								<td class="boldFont greyColor descending">
									<base-mostrar-markdown
										:agregado="
											row.respuestaDada.opcion
												? `**${row.respuestaDada.opcion}.**`
												: undefined
										"
										style="display: inline-block;"
										:contenido="row.respuestaDada.contenido"
									/>
								</td>
								<td class="boldFont greyColor descending aligned">
									<base-mostrar-markdown
										:agregado="
											row.respuestaCorrecta.opcion
												? `**${row.respuestaCorrecta.opcion}.**`
												: undefined
										"
										style="display: inline-block;"
										:contenido="row.respuestaCorrecta.contenido"
									/>
								</td>
							</template>
							<template v-else-if="row.seccionResultado">
								<td
									colspan="5"
									class="boldFont greyColor descending right aligned"
								>
									Total sección
								</td>
								<td class="boldFont greyColor descending center aligned">
									<b class="boldFont greyColor"> {{ row.seccionResultado }}</b>
								</td>
							</template>
							<template v-else-if="row.areaResultado">
								<td
									colspan="5"
									class="boldFont greyColor descending right aligned"
								>
									Total área de conocimiento
								</td>
								<td class="boldFont greyColor descending center aligned">
									<b class="boldFont greyColor"> {{ row.areaResultado }}</b>
								</td>
							</template>
						</tr>
						<tr style="background:#f9fafb;">
							<td
								colspan="5"
								class="boldFont greyColor descending right aligned"
							>
								Total general
							</td>
							<td class="boldFont greyColor descending center aligned">
								<b class="boldFont greyColor"> {{ examen.calificacion }}</b>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</BaseContenedor>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Vue from 'vue';

export default {
	page: {
		title: 'Examen - Aspirante',
		meta: [{ name: 'description', content: 'The examen aspirante page.' }]
	},
	data: function() {
		return {
			examenesAspirantes: []
		};
	},
	computed: {
		...mapGetters('configuraciones', ['getLogoPlantel', 'getNombrePlantel']),
		...mapGetters('examenAspirantes', ['getExamenAspiranteResultado'])
	},
	watch: {},
	mounted() {
		this.establecerUrlAtras(`/examenes/resultados/${this.$route.params.clave}`);
		if (this.$route.params.clave) {
			this.obtenerExamen({
				clave: this.$route.params.clave,
				onComplete: (response) => {
					this.obtenerExamenAspiranteResultados({
						ficha: this.$route.params.ficha,
						onComplete: (responseAspirante) => {
							this.setearAspirante(
								response.data.data,
								responseAspirante.data.data
							);
							this.establecerTitulo(
								`Examen ${response.data.data.nombre} de ${responseAspirante.data.data.nombreCompleto} `
							);
						}
					});
				}
			});
		}
	},
	methods: {
		...mapActions('app', ['establecerTitulo', 'establecerUrlAtras']),
		...mapActions('examenes', ['obtenerExamen']),
		...mapActions('examenAspirantes', ['obtenerExamenAspiranteResultados']),
		getCalificacionSeccion(area, seccion, aspiranteExamen) {
			return (
				this.getPreguntasCorrectasSeccion(area, seccion, aspiranteExamen) +
				' / ' +
				this.getTotalPreguntasSeccion(area, seccion, aspiranteExamen)
			);
		},
		getPreguntasCorrectasSeccion(area, seccion, aspiranteExamen) {
			return aspiranteExamen.areasDeConocimiento
				.find((x) => x.clave === area.clave)
				.secciones.find((x) => x.clave === seccion.clave).preguntasCorrectas;
		},
		getTotalPreguntasSeccion(area, seccion, aspiranteExamen) {
			return aspiranteExamen.areasDeConocimiento
				.find((x) => x.clave === area.clave)
				.secciones.find((x) => x.clave === seccion.clave).preguntas.length;
		},
		getCalificacionAspirante(aspiranteExamen = { areasDeConocimiento: [] }) {
			return (
				this.getPreguntasCorrectasAspirante(aspiranteExamen) +
				' / ' +
				this.getTotalPreguntasAspirante(aspiranteExamen)
			);
		},
		getPreguntasCorrectasAspirante(aspiranteExamen) {
			return aspiranteExamen.areasDeConocimiento
				.map((x) => x.preguntasCorrectas)
				.reduce((a, b) => a + b, 0);
		},
		getTotalPreguntasAspirante(aspiranteExamen) {
			return aspiranteExamen.areasDeConocimiento
				.map((x) => x.totalPreguntas)
				.reduce((a, b) => a + b, 0);
		},
		setearAspirante(examen, examenAspirante) {
			const {
				ficha,
				nombreCompleto,
				curp,
				claveCarrera,
				nombreCortoCarrera
			} = examenAspirante;
			const tabla = this.getTable(examen, examenAspirante);
			const calificacion = this.getCalificacionAspirante(examenAspirante);
			Vue.set(this, 'examenesAspirantes', [
				{
					ficha,
					nombreCompleto,
					curp,
					claveCarrera,
					nombreCortoCarrera,
					tabla,
					calificacion
				}
			]);
		},
		getTable(examen, aspirante) {
			const rows = [];
			examen.areasDeConocimientos.forEach((area) => {
				const areaExamenAspirante = (aspirante.areasDeConocimiento || []).find(
					(x) => x.clave === area.clave
				) || { secciones: [] };
				rows.push({ area, areaExamenAspirante });
				area.secciones.forEach((seccion) => {
					const seccionExamenAspirante = areaExamenAspirante.secciones.find(
						(x) => x.clave === seccion.clave
					) || { preguntas: [] };
					rows.push({ seccion, seccionExamenAspirante });
					seccion.preguntas.forEach((pregunta) => {
						const preguntaExamenAspirante = seccionExamenAspirante.preguntas.find(
							(x) =>
								x.clave === pregunta.clavePregunta &&
								x.claveBanco === pregunta.claveBanco
						);
						if (preguntaExamenAspirante) {
							rows.push({ pregunta, preguntaExamenAspirante });
							let respuestaDada = {};
							let respuestaCorrecta = {};
							if (preguntaExamenAspirante.respuestaDada)
								respuestaDada =
									pregunta.respuestas.find(
										(x) => x.opcion === preguntaExamenAspirante.respuestaDada
									) || {};
							if (preguntaExamenAspirante.respuestaCorrecta)
								respuestaCorrecta =
									pregunta.respuestas.find(
										(x) =>
											x.opcion === preguntaExamenAspirante.respuestaCorrecta
									) || {};
							rows.push({ respuestaDada, respuestaCorrecta });
						}
					});
					rows.push({
						seccionResultado:
							seccionExamenAspirante.preguntasCorrectas +
							' / ' +
							seccionExamenAspirante.preguntas.length
					});
				});
				rows.push({
					areaResultado:
						areaExamenAspirante.preguntasCorrectas +
						' / ' +
						areaExamenAspirante.totalPreguntas
				});
			});
			Object.freeze(rows);
			return rows;
		},
		imprimir() {
			const milisegundos = 2000;
			this.$htmlToPaper('printMe', null, milisegundos);
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';
</style>
